import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Avatar, Box, Button, Flex, mode, Text, useColorMode, VStack } from '@abb/uikit';
import { ChevronRight } from '@abb/uikit/icons/outline/arrow';
import { Check } from '@abb/uikit/icons/outline/general';
import { useCustomers, useDependencies, useSetToken } from 'hooks';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Logout } from '../user-settings/logout';
import { HeaderResponsive } from './HeaderResponsive';
export const CustomerModal = (param)=>{
    let { onSidebarOpen } = param;
    var _userService_getProcessClaims, _userInfo_customers;
    const { t } = useTranslation('common');
    const { colorMode } = useColorMode();
    const [open, setOpen] = useState(false);
    const { trigger } = useSetToken();
    const { userService } = useDependencies();
    const userData = userService === null || userService === void 0 ? void 0 : userService.getUserData;
    const onCloseDrower = ()=>{
        setOpen(false);
        onSidebarOpen();
    };
    const userInfo = userService === null || userService === void 0 ? void 0 : userService.getUserData;
    const selectedCif = userService === null || userService === void 0 ? void 0 : (_userService_getProcessClaims = userService.getProcessClaims) === null || _userService_getProcessClaims === void 0 ? void 0 : _userService_getProcessClaims.customerId;
    const selectedUserInfo = userInfo === null || userInfo === void 0 ? void 0 : (_userInfo_customers = userInfo.customers) === null || _userInfo_customers === void 0 ? void 0 : _userInfo_customers.find((item)=>item.customerId === selectedCif);
    const { data } = useCustomers();
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs(Flex, {
                justifyContent: "space-between",
                alignItems: "center",
                w: "calc(100% - 16px)",
                bg: mode('#F5F5F5', '#292B2E')({
                    colorMode
                }),
                border: `1px solid ${mode('#0A0B0D14', '#FFFFFF14')({
                    colorMode
                })}`,
                p: "16px 12px",
                mx: 2,
                onClick: ()=>setOpen(!open),
                borderRadius: "16px",
                children: [
                    /*#__PURE__*/ _jsxs(Flex, {
                        alignItems: "center",
                        gap: "10px",
                        children: [
                            /*#__PURE__*/ _jsx(Avatar, {
                                name: userData === null || userData === void 0 ? void 0 : userData.customers[0].name
                            }),
                            /*#__PURE__*/ _jsxs(Box, {
                                children: [
                                    /*#__PURE__*/ _jsx(Text, {
                                        width: "110px",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                        fontSize: "14px",
                                        children: userData === null || userData === void 0 ? void 0 : userData.customers[0].name
                                    }),
                                    /*#__PURE__*/ _jsxs(Text, {
                                        width: "90px",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                        fontSize: "12px",
                                        children: [
                                            userData.firstName,
                                            " ",
                                            userData.lastName
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        variant: "gray",
                        size: "lg",
                        borderRadius: "99px",
                        children: t('actions.logout')
                    })
                ]
            }),
            open && /*#__PURE__*/ _jsxs(Box, {
                borderRadius: "24px",
                p: 3,
                bg: mode('#F0F0F0', '#0A0B0D')({
                    colorMode
                }),
                position: "fixed",
                zIndex: 2,
                top: "0",
                left: 0,
                h: "calc(100dvh - 16px)",
                w: "100%",
                children: [
                    /*#__PURE__*/ _jsx(HeaderResponsive, {
                        onCloseSidebar: onCloseDrower,
                        responsiveSetOpenModal: setOpen,
                        responsiveOpenModal: open
                    }),
                    /*#__PURE__*/ _jsxs(VStack, {
                        width: "100%",
                        border: "1px solid",
                        borderColor: mode('#F0F0F0', '#0A0B0D')({
                            colorMode
                        }),
                        borderRadius: "16px",
                        justifyContent: "space-between",
                        mb: "24px",
                        overflow: "auto",
                        children: [
                            /*#__PURE__*/ _jsx(Box, {
                                h: "calc(100dvh - 200px)",
                                overflow: "auto",
                                children: data === null || data === void 0 ? void 0 : data.map((item)=>/*#__PURE__*/ _jsxs(Flex, {
                                        cursor: "pointer",
                                        onClick: ()=>(userData === null || userData === void 0 ? void 0 : userData.customers[0].name) !== item.name && trigger({
                                                cif: item.cif
                                            }),
                                        p: 4,
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        children: [
                                            /*#__PURE__*/ _jsxs(Flex, {
                                                gap: 3,
                                                alignItems: "center",
                                                children: [
                                                    /*#__PURE__*/ _jsx(Avatar, {
                                                        borderColor: "white",
                                                        size: "sm",
                                                        name: item.name
                                                    }),
                                                    /*#__PURE__*/ _jsx(Text, {
                                                        width: "200px",
                                                        textTransform: "none",
                                                        overflow: "hidden",
                                                        textOverflow: "ellipsis",
                                                        whiteSpace: "nowrap",
                                                        children: item.name
                                                    })
                                                ]
                                            }),
                                            (userData === null || userData === void 0 ? void 0 : userData.customers[0].name) === item.name ? /*#__PURE__*/ _jsx(Check, {}) : /*#__PURE__*/ _jsx(ChevronRight, {})
                                        ]
                                    }, item.cif))
                            }),
                            /*#__PURE__*/ _jsxs(Box, {
                                w: "100%",
                                children: [
                                    (selectedUserInfo === null || selectedUserInfo === void 0 ? void 0 : selectedUserInfo.director) && /*#__PURE__*/ _jsx(Button, {
                                        as: Link,
                                        to: "/accountopening",
                                        mb: 2,
                                        borderRadius: "12px",
                                        w: "100%",
                                        cursor: "pointer",
                                        children: t('menu.new_account')
                                    }),
                                    /*#__PURE__*/ _jsx(Logout, {})
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
